var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoInfoGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.563C7.5913 12.563 9.11742 11.9308 10.2426 10.8056C11.3679 9.68041 12 8.15429 12 6.56299C12 4.97169 11.3679 3.44557 10.2426 2.32035C9.11742 1.19513 7.5913 0.562988 6 0.562988C4.4087 0.562988 2.88258 1.19513 1.75736 2.32035C0.632141 3.44557 0 4.97169 0 6.56299C0 8.15429 0.632141 9.68041 1.75736 10.8056C2.88258 11.9308 4.4087 12.563 6 12.563ZM5.0625 8.43799H5.625V6.93799H5.0625C4.75078 6.93799 4.5 6.68721 4.5 6.37549C4.5 6.06377 4.75078 5.81299 5.0625 5.81299H6.1875C6.49922 5.81299 6.75 6.06377 6.75 6.37549V8.43799H6.9375C7.24922 8.43799 7.5 8.68877 7.5 9.00049C7.5 9.31221 7.24922 9.56299 6.9375 9.56299H5.0625C4.75078 9.56299 4.5 9.31221 4.5 9.00049C4.5 8.68877 4.75078 8.43799 5.0625 8.43799ZM6 3.56299C6.19891 3.56299 6.38968 3.64201 6.53033 3.78266C6.67098 3.92331 6.75 4.11408 6.75 4.31299C6.75 4.5119 6.67098 4.70267 6.53033 4.84332C6.38968 4.98397 6.19891 5.06299 6 5.06299C5.80109 5.06299 5.61032 4.98397 5.46967 4.84332C5.32902 4.70267 5.25 4.5119 5.25 4.31299C5.25 4.11408 5.32902 3.92331 5.46967 3.78266C5.61032 3.64201 5.80109 3.56299 6 3.56299Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInfoGrey);
export default __webpack_public_path__ + "static/media/ico-info-grey.bd51568cddcddf1bcedab9b5985dae58.svg";
export { ForwardRef as ReactComponent };